export { default } from './SpecsComparison.js'
export type { SpecsComparisonProps, SpecsComparisonMenuItem, SpecsComparisonLeftMenuItem } from './types.js'
